//@flow
export const getToolTipMessage = (productGroup: string, action: string) => {
  if (action === "extension") {
    return `We love that you love your ${productGroup}! You're welcome to extend your booking for as long as it's available.`
  }
  return `If your ${productGroup} is just not cutting it, swap it!`
}



// WEBPACK FOOTER //
// ./src/pages/Reservation/ExtendReservation/messages.js